import {
    CoachingEventStatus,
    CoachingEventType,
    CommitmentDto,
    CommitmentEvent,
    DeliveryType,
    Focus,
} from '../coaching-base/general';

function createFocus(): Focus {
    return {
        focusId: undefined,
        userId: undefined,
        behaviourId: undefined,
        subBehaviourId: undefined,
        createdBy: undefined,
        createdOn: undefined,
    };
}

function createEvent(
    eventTypeId: CoachingEventType,
    deliveryTypeId?: DeliveryType,
    sessionDate?: Date,
    duration?: number,
    startTime?: Date,
): CommitmentEvent {
    if (eventTypeId == null) {
        throw new Error('eventTypeId must be defined');
    }
    const now = new Date();
    return {
        eventTypeId,
        deliveryTypeId:
            deliveryTypeId != null ? deliveryTypeId : DeliveryType.SIDE_BY_SIDE,
        sessionDate: sessionDate || now,
        duration: duration != null ? duration : 0,
        shareWithPerformer: false,
        published: false,
        startTime: startTime || now,
    };
}

export function createCommitment(performerId: number): CommitmentDto {
    return {
        commitmentId: undefined,
        performerId,
        statusId: CoachingEventStatus.DRAFT,
        focus: createFocus(),
        totalDuration: 0,
        latestEvent: createEvent(CoachingEventType.COMMITMENT),
        latestEventParticipants: [],
        notes: [],
        observations: [],
        goals: [],
    };
}
